import { render, staticRenderFns } from "./Advices.vue?vue&type=template&id=7dae7288"
import script from "./Advices.vue?vue&type=script&lang=js"
export * from "./Advices.vue?vue&type=script&lang=js"
import style0 from "./Advices.vue?vue&type=style&index=0&id=7dae7288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports